export default "__VITE_ASSET__BW3z3Lin__"